import React from 'react'
import {
  Container,
  Row,
  Col,
  Alert,
} from 'reactstrap'
import TopNavigation from '../../TopNavigation'
import withAppconfig from '../../AppContext'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import EventTicketCard from '../../components/Shop/EventTicketCard'
import moment from 'moment'
// import ProductCard from '../../components/Shop/ProductCard'

const mapStateToProps = (state, props) => {
  const {
    firebase,
    globaltime,
  } = state
  if(!firebase.ordered.shopeventtickets) return { eventtickets: null }
  const eventtickets = firebase.ordered.shopeventtickets.map((m) => {
    const poster = m.value.image
    const order = m.value.order ? parseInt(m.value.order) : 0
    return { id: m.key, ...m.value, poster: poster, order: order }
  }).sort((a, b) => b.order - a.order)

  // remove earlybird tickets if earlybirddeadline has passed
  const gtime = globaltime && globaltime.gtime ? globaltime.gtime : null
  console.log('EventTicketsScreen mapStateToProps', { gtime, eventtickets })
  if (gtime) {
    eventtickets.forEach((m) => {
      if (m.variations && m.variations.length > 0) {
        m.variations = m.variations.filter((v) => {
          if (v.earlybirddeadline) {
            // just remove earlybindprice and earlybirddeadline if deadline has passed
            const earlybirddeadline = moment(v.earlybirddeadline)
            if (gtime.isAfter(earlybirddeadline)) {
              delete v.earlybirdprice
              delete v.earlybirddeadline
            }
          }
          return true
        })
      }
    })
    console.log('EventTicketsScreen mapStateToProps after filtering', { gtime, eventtickets })
  }

  return {
    eventtickets,
  }
}

const withProducts = compose(
  connect((state) => ({ auth: state.firebase.auth })),
  firebaseConnect((props) => [
    {
      path: 'shop/' + props.appconfig.accountkey + '/eventtickets',
      // queryParams: ['orderByChild=startDate'],
      storeAs: 'shopeventtickets',
    },
  ]),
  connect(mapStateToProps)
)

function EventTicketsScreen({ appconfig, eventtickets, auth }) {
  const { t } = useTranslation()
  const isAuth = true //auth.isLoaded && !auth.isEmpty
  return (
    <div className='full-page-background'>
      <TopNavigation />
      <Container className='front' style={{ paddingTop: 10 }}>
        <Typography variant='h6' style={{ paddingBottom: 20 }}>
          {t('eventtickets')}
        </Typography>
        {eventtickets && eventtickets.length > 0 ? (
          <Row>
            {eventtickets.map((m) => (
              <Col key={m.id} xs={12} sm={12}>
                <EventTicketCard product={m} collection={'eventtickets'} isAuthRequired={false} isAuth={isAuth} />
              </Col>
            ))}
          </Row>
        ) : (
          null
        )}
      </Container>
    </div>
  )
}

export default withAppconfig(withProducts(EventTicketsScreen))
